module.exports = __webpack_public_path__ + "img/stop_btn.f905f808.png";